// ie polyfill
import './polyfills/replaceAll'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import { installViteDiagnostics } from './utils/viteDiagnostics'
installViteDiagnostics(Vue, router)
import VideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
Vue.use(VideoPlayer)
import { VueAxios } from './utils/request'
import '@/utils/'
import './assets/icons/register'
import bootstrap from './core/bootstrap'
// 先执行 bootstrap 设置默认值，再导入 ant-design-vue
bootstrap()
import './core/use'
import './permission'
import './utils/filter'
import i18n from './locales'

import '@/components/global'
import BaiduMap from 'vue-baidu-map'
import 'element-ui/lib/theme-chalk/index.css'
import Table from 'element-ui/lib/table'
import TableColumn from 'element-ui/lib/table-column'
import Progress from 'element-ui/lib/progress'
import Radio from 'element-ui/lib/radio'
import InputNumber from 'element-ui/lib/input-number'
import Image from 'element-ui/lib/image'
import Upload from 'element-ui/lib/upload'
import Cascader from 'element-ui/lib/cascader'
Vue.config.productionTip = false

import VueAMap from '@vuemap/vue-amap'
import '@vuemap/vue-amap/dist/style.css'
Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: 'ad21b67b5d12d07943e8833a8507fb63',
  plugin: ['AMap.Geocoder', 'AMap.Autocomplete']
})

Vue.use(Table)
Vue.use(Upload)
Vue.use(InputNumber)
Vue.use(TableColumn)
Vue.use(Progress)
Vue.use(Radio)
Vue.use(Image)
Vue.use(Cascader)
Vue.use(VueAxios)

import validators from './plugs/validators'

Vue.use(validators)

import Vuebar from 'vuebar'

Vue.use(Vuebar)

Vue.use(BaiduMap, {
  ak: 'GRSSrDoLEPcyWbsSKfWS463CguPC5wKe'
})

import Print from './utils/print'
Vue.use(Print)

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
